import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useTextEnableLandlineContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineContext'
import { VerifyNumberCommon } from 'pages/settings/ui/VerifyNumberCommon'

export const VerifyNumber = observer(() => {
  const { verifyNumberStore } = useTextEnableLandlineContext()
  const { disposeStep } = verifyNumberStore

  useEffect(() => {
    return () => {
      disposeStep()
    }
  }, [])

  return <VerifyNumberCommon store={verifyNumberStore} />
})
